import { Stack } from '@castlery/fortress';
import { ProductBundleOptions } from './components/product-bundle-options/product-bundle-options';
import { ProductConfigurableOptions } from './components/product-configurable-options/product-configurable-options';
import { ProductModel } from './components/product-model/product-model';
import { ProductConfigClient } from './product-config.client';

interface ProductConfigServerProps {
  slug: string;
  promise: Promise<any>;
  pageType: 'pdp' | 'pla';
}

export const ProductConfigServer = async (props: ProductConfigServerProps) => {
  const { slug, promise, pageType } = props;
  try {
    const productData = await promise;
    return (
      <Stack>
        <ProductConfigClient />
        <ProductModel slug={slug} pageType={pageType} />
        {productData?.product_type === 'bundle' ? <ProductBundleOptions /> : <ProductConfigurableOptions />}
      </Stack>
    );
  } catch (error) {
    return null;
  }
};
